<template>
  <div v-if="!src">
    <div :class="color" :style="style" class=" avatar colorful-avatar">
      <table>
        <tbody>
        <tr>
          <td v-if="!hasImage && !icon" class="lighten-bold">
            {{ initials }}
          </td>
          <td v-if="icon">

            <i :class=" `${icon}`" class="icon-color"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else>
    <img
      :height="heightImg"
      :src="src"
      :width="widthImg"
      alt
      class="img-fluid img-thumbnail rounded-circle z-depth-2"
    >
  </div>
</template>

<script>
export default {
  props: {
    fullName: {type: String, default: ''},
    size: {type: Number, default: 48},
    radius: {
      type: Number,
      default: 50,
      validator: value => value >= 0 && value <= 50,
    },
    color: {type: String, default: ''},
    image: {type: String, default: ''},
    icon: {
      type: String,
      default: '',
    },
    src: {type: String, default: ''},
    heightImg: {type: Number, default: 96},
    widthImg: {type: Number, default: 96},
  },

  data() {
    return {
      colorTest: 'red',
    }
  },
  computed: {
    initials() {
      const words = this.fullName.split(/[\s-]+/)
      return words.map(word => word.substr(0, 1)).join('').substr(0, 3).toUpperCase()
    },
    style() {
      const fontSize = this.initials.length > 2 ? this.size / 3 : this.size / 2
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        'border-radius': `${this.radius}%`,
        'font-size': `${fontSize}px`,
        'background-image': this.hasImage ? `url(${this.image})` : 'none',
      }
    },
    hasImage() {
      return this.image !== ''
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
